import { Injectable } from "@angular/core";
import { Adapter } from "src/app/core/adapter";

export class Brand {

    constructor(
        public label:string,
        public value: string,
    ) {}
}

    @Injectable({
        providedIn: "root"
    })

    export class BrandAdapter implements Adapter<Brand> {
        adapt(item:any): Brand {
            return new Brand(item.brandName,item.brandId);
       }
    }

